<template>
	<div class="themed-summary" :class="summaryClass">
		<div
			v-for="(item, index) in items"
			:key="index"
			class="themed-summary__item"
		>
			<div class="themed-summary__value">{{ item.value }}</div>
			<div class="themed-summary__label">{{ item.label }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ThemedSummary',
	
	props: {
		// Array of summary items
		// Example: [{ value: '5', label: 'Projects' }, { value: '$1.2M', label: 'Total' }]
		items: {
			type: Array,
			required: true,
			validator: (items) => {
				return items.every(item => 
					item.value !== undefined && 
					item.label !== undefined
				);
			}
		},
		
		// Layout variant
		variant: {
			type: String,
			default: 'default',
			validator: (value) => ['default', 'compact', 'large'].includes(value)
		},
		
		// Additional CSS class
		summaryClass: {
			type: String,
			default: ''
		}
	}
}
</script>
